<ng-template [ngIf]="typeLabel == 'text'">
    <div>
        <label [attr.for]="'text_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'text_' + randomId"
            [ngClass]="{'form-control':formControlClass, 'red-text': errorColor}" disabled=""
            value="{{valueInput ? valueInput : ''}}" type="text">
        <span class="print">{{valueInput ? valueInput : ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'textarea'">
    <div>
        <label [innerHTML]="labelInput"></label>
        <span class="longtext">{{valueInput ? valueInput : ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'date'">
    <div>
        <label [attr.for]="'date_' + randomId"
            [ngStyle]="{'font-family': (position === 'dati_generali') ? 'open_sans_bold' : ''}"
            [innerHTML]="labelInput"></label>
        <input [attr.id]="'date_' + randomId" disabled=""
            value="{{valueInput ? (valueInput | dateformatter:'DD/MM/YYYY'): ''}}" type="text">
        <span class="print">{{valueInput ? (valueInput | dateformatter:'DD/MM/YYYY'): ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'dateTime'">
    <div>
        <label [attr.for]="'dateTime_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'dateTime_' + randomId" disabled=""
            value="{{valueInput ? (valueInput | dateformatter:'DD/MM/YYYY HH:mm'): ''}}" type="text">
        <span class="print">{{valueInput ? (valueInput | dateformatter:'DD/MM/YYYY HH:mm'): ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'boolean'">
    <div>
        <label [attr.for]="'boolean_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'boolean_' + randomId" disabled="" value="{{valueInput ? 'Si' : 'No'}}"
            type="text">
        <span class="print">{{valueInput ? 'Si' : 'No'}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'importo'">
    <div>
        <label [attr.for]="'importoText_' + randomId" [innerHTML]="labelInput"></label>
        <span class="sr-only">{{getLabel(valueInput ? (valueInput | euro)+' \u20AC' : '')}}</span>
        <input [attr.id]="'importoText_' + randomId" disabled=""
            value="{{valueInput ? (valueInput | euro)+' \u20AC' : ''}}" type="text" aria-hidden="true">
        <span class="print">{{valueInput ? (valueInput | euro)+' \u20AC' : ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'decimale'">
    <div>
        <label [attr.for]="'decimale_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'decimale_' + randomId" disabled=""
            value="{{valueInput ? (valueInput | euro) : ''}}" type="text">
        <span class="print">{{valueInput ? (valueInput | euro) : ''}}</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'percentualeDec'">
    <div>
        <label [attr.for]="'percentualeDec_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'percentualeDec_' + randomId" disabled=""
            value="{{valueInput ? (valueInput | euro) : 0}} %" type="text">
        <span class="print">{{valueInput ? (valueInput | euro) : 0}} %</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'percentuale'">
    <div>
        <label [attr.for]="'percentuale_' + randomId" [innerHTML]="labelInput"></label>
        <input [attr.id]="'percentuale_' + randomId" disabled=""
            value="{{valueInput ? valueInput : 0}} %" type="text">
        <span class="print">{{valueInput ? valueInput : 0}} %</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'listModal'">
    <div [ngClass]="classLabel" class="bloccodati">
        <div><label [attr.for]="'listModal_' + randomId" [innerHTML]="labelInput"></label></div>
    </div>
    <div [ngClass]="classInput" class="bloccodati">
        <div><input [attr.id]="'listModal_' + randomId" class="form-control" disabled=""
                value="{{valueInput ? valueInput : ''}}" type="text"></div>
        <span class="print">{{valueInput ? valueInput : ''}}</span>
    </div>
</ng-template>

<ng-template [ngIf]="typeLabel == 'checklist'">
    <div><label [innerHTML]="labelInput"></label></div>
    <ul class="listacheck">
        <li *ngFor="let item of checkListValue">
            <ng-template [ngIf]="item.label">{{item.descrizione}}</ng-template>
        </li>
    </ul>
</ng-template>
<ng-template [ngIf]="typeLabel == 'conteggio'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}} bloccodati"><label [attr.for]="'conteggio_' + randomId"
                [innerHTML]="labelInput"></label></div>
        <div class="col-sm-{{valueCol}} bloccodati">
            <span class="sr-only" style="width: 100%; text-align: right;">{{getLabel(valueInput ? (valueInput | euro)+'
                \u20AC' : '')}}</span>
            <input [attr.id]="'conteggio_' + randomId" disabled="" class="form-control alignright"
                name="importo" value="{{(valueInput ? valueInput : 0) | euro}} &euro;" type="text" aria-hidden="true">
            <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
        </div>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'conteggioProspetto'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}} bloccodati"><label [attr.for]="'conteggioProspetto_' + randomId"
                [innerHTML]="labelInput"></label>
        </div>
        <div class="col-sm-{{valueCol}} bloccodati">
            <span class="sr-only" style="width: 100%; text-align: right;">{{getLabel(valueInput ? (valueInput | euro)+'
                \u20AC' : '')}}</span>
            <input [attr.id]="'conteggioProspetto_' + randomId" disabled=""
                class="formControlClass alignright" name="importo"
                value="{{(valueInput ? valueInput : 0) | euro}} &euro;" type="text" aria-hidden="true">
            <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="typeLabel == 'conteggioProspettoPercentualeApplicata'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}} bloccodati"><label
                [attr.for]="'conteggioProspettoPercentualeApplicata_' + randomId">{{labelInput}}
                ({{percentuale
                |
                euro}}% di {{valoreNum | euro}})</label></div>
        <div class="col-sm-{{valueCol}} bloccodati"><input
                [attr.id]="'conteggioProspettoPercentualeApplicata_' + randomId" disabled=""
                class="formControlClass alignright" name="importo"
                value="{{(valueInput ? valueInput : 0) | euro}} &euro;" type="text">
            <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="typeLabel == 'conteggioProspettoPerc'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}} bloccodati"><label
                [attr.for]="'conteggioProspettoPerc_' + randomId" [innerHTML]="labelInput"></label>
        </div>
        <div class="col-sm-{{valueCol}} bloccodati"><input
                [attr.id]="'conteggioProspettoPerc_' + randomId" disabled=""
                class="formControlClass alignright" name="importo" value="{{(valueInput ? valueInput : 0) | euro}}"
                type="text">
            <span class="print">{{(valueInput ? valueInput : 0)}}%;</span>
        </div>
    </div>

</ng-template>

<ng-template [ngIf]="typeLabel == 'incassi'">
    <div class="col-sm-4 bloccodati"><label [attr.for]="'incasso_' + randomId"
            [innerHTML]="labelInput"></label></div>
    <div class="col-sm-4 bloccodati"><label [innerHTML]="codiceImporto"></label></div>
    <div class="col-sm-4 bloccodati">
        <span class="sr-only" style="width: 100%; text-align: right;">{{getLabel(valueInput ? (valueInput | euro)+'
            \u20AC' : '')}}</span>
        <input [attr.id]="'incasso_' + randomId" disabled="" class="formControlClass alignright"
            name="importo" value="{{(valueInput ? valueInput : 0) | euro}} &euro;" type="text" aria-hidden="true">
        <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
    </div>
</ng-template>
<ng-template [ngIf]="typeLabel == 'conteggioBold'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}}"><label [attr.for]="'conteggioBold_' + randomId"
                [innerHTML]="'<strong>' + labelInput + '</strong>'"></label></div>
        <div class="col-sm-{{valueCol}} bloccodati">
            <span class="sr-only">{{getLabel(valueInput ? (valueInput | euro)+'
                \u20AC' : '')}}</span>
            <input [attr.id]="'conteggioBold_' + randomId" disabled=""
                class="form-control totale alignright" value="{{(valueInput ? valueInput : 0) | euro}} &euro;"
                type="text" aria-hidden="true">
            <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
        </div>
    </div>

</ng-template>
<ng-template [ngIf]="typeLabel == 'conteggioProspettoBold'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}}"><label [attr.for]="'conteggioProspettoBold_' + randomId"
                [innerHTML]="'<strong>' + labelInput + '</strong>'"></label>
        </div>
        <div class="col-sm-{{valueCol}} bloccodati">
            <span class="sr-only">{{getLabel(valueInput ? (valueInput | euro)+' \u20AC' : '')}}</span>
            <input [attr.id]="'conteggioProspettoBold_' + randomId" disabled=""
                class="formControlClass totale alignright" value="{{(valueInput ? valueInput : 0) | euro}} &euro;"
                type="text" aria-hidden="true">
            <span class="print">{{(valueInput ? valueInput : 0) | euro}} &euro;</span>
        </div>
    </div>

</ng-template>
<ng-template [ngIf]="typeLabel == 'conteggioPerc'">
    <div class="conteggio">
        <div class="col-sm-{{labelCol}} bloccodati"><label [attr.for]="'conteggioPerc_' + randomId"
                [innerHTML]="labelInput"></label></div>
        <div class="col-sm-{{valueCol}} bloccodati"><input [attr.id]="'conteggioPerc_' + randomId"
                disabled="" class="form-control alignright" name="importo" value="{{valueInput ? valueInput : 0}} %"
                type="text">
            <span class="print">{{valueInput ? valueInput : 0}} %</span>
        </div>
    </div>

</ng-template>

<ng-template [ngIf]="typeLabel == 'list'">
    <label [innerHTML]="labelInput"></label>
    <ul class="lista-bloccodati" [attr.id]="'lista-valori_' + randomId">
        <li *ngFor="let item of listValue" class="list-item">
            {{ item | TraduzioniPipe }}
        </li>
    </ul>
</ng-template>